import { api } from "../client";

const API_MODULE =
  process.env.REACT_APP_API_MODULE || "dynesourcerapi.author";

/** Frappe often puts readable errors in _server_messages as escaped JSON. */
export function extractGoogleLoginError(json) {
  if (!json) return null;
  if (json._server_messages) {
    try {
      const first = JSON.parse(JSON.parse(json._server_messages)[0]);
      if (first?.message) {
        return String(first.message).replace(/<[^>]*>/g, "");
      }
    } catch {
      // fall through
    }
  }
  if (json.exception) {
    return String(json.exception).split("\n").pop() || null;
  }
  if (typeof json.message === "string") return json.message;
  if (typeof json.message?.message === "string") return json.message.message;
  return null;
}

/**
 * Exchange Google ID token for the same api_key / api_secret pair as password login.
 * POST /api/method/dynesourcerapi.author.google_login
 * Sends role like custom_signup so new users get Borrower (or Lender) assigned server-side.
 *
 * @param {string} idToken
 * @param {{ role?: "Borrower"|"Lender" }} [options]
 */
export async function loginWithGoogleToken(idToken, options = {}) {
  const role = options.role || "Borrower";
  try {
    const res = await api.post(`/api/method/${API_MODULE}.google_login`, {
      id_token: idToken,
      role,
    });
    const json = res?.data ?? {};
    const payload = json?.message ?? json;
    if (!payload?.api_key || !payload?.api_secret) {
      throw new Error(extractGoogleLoginError(json) || "Google sign-in failed");
    }
    return {
      data: json,
      headers: res.headers,
      payload,
    };
  } catch (err) {
    if (err?.message && !err?.response) throw err;
    const json = err?.response?.data;
    throw new Error(extractGoogleLoginError(json) || err?.message || "Google sign-in failed");
  }
}
